<template>
    <v-container class="mx-auto flex flex-col items-center justify-center space-y-lg px-sm pb-3xl lg:w-[900px]">
        <slot></slot>
    </v-container>
</template>

<script lang="ts" setup>
import type { ISbStoryData } from 'storyblok-js-client';

const properties = defineProps<{
    story: ISbStoryData
}>();

useSeoMeta({
    title: properties.story.content.meta?.title || properties.story.name,
    // eslint-disable-next-line max-len
    description: (properties.story.content.meta?.description || properties.story.content?.short_description) ?? undefined,
    ogTitle: properties.story.content.meta?.title || properties.story.content.title || properties.story.name,
    // eslint-disable-next-line max-len
    ogDescription: (properties.story.content.meta?.description || properties.story.content?.short_description) ?? undefined,
    ogImage: properties.story.content?.og_image?.filename ?? undefined,
});
</script>
